module.exports = __webpack_public_path__ + "static/animated-favicon-6729fbff4c35e2303f41f187bebf43c0.gif";